import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "./style.scss";
import { ReactComponent as IconRest } from "../../assets/icons/restaurant.svg"
import { ReactComponent as IconTakeaway } from "../../assets/icons/takeout_dining.svg"
import { ReactComponent as IconCheck } from "../../assets/icons/check.svg"
import { OrderType } from "../../@types/enums/OrderType";
import { useLocation, useNavigate } from "react-router";
import orderStore from "../../stores/order";
import menuStore from "../../stores/menu";
import {addToLog, clearLogs, getAllowedTypes, getHost, isRetail} from "../../helpers/ApiHelper";
import { hideAlert } from "../../helpers/ComponentHelper";
import ApiGlobalSettings from "../../@types/api/settings";
import { defLangs, getLanguages } from "../../helpers/LangHelper";
import useLayoutStyles from "../../hooks/styles";

const Welcome = () => {
    const [t, i18n] = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const styles = useLayoutStyles();

    const [languages, setLanguages] = useState<string[]>(defLangs);

    useEffect(() => {
        hideAlert();
        orderStore.cancelOrder();
        clearLogs();
    }, [location]);

    useEffect(() => {
        setLanguages(getLanguages());
        const defLang = getDefLanguage();
        if (defLang)
            changeLang(defLang);
    }, [localStorage.getItem("settings")]);

    const getDefLanguage = (): string => {
        let lang = localStorage.getItem("i18nextLng") || "en";
        const strSettings = localStorage.getItem("settings");
        if (strSettings) {
            try {
                const settings = JSON.parse(strSettings) as ApiGlobalSettings;
                lang = settings?.primaryLanguage?.trim().toLowerCase() || "en";
            }
            catch (e) {
                // ignore
            }
        }

        return lang;
    }

    const changeLang = (code: string) => {
        addToLog(`Change language to ${code}`);
        i18n.changeLanguage(code);
    }

    const setType = async (type: OrderType) => {
        addToLog(`Set type = ${type}`);
        orderStore.setType(type);
        await menuStore.getMenu(true);
        const apiOrder = await orderStore.createOrder();
        if (apiOrder) {
            if (styles?.behavior?.skipCustomer)
                navigate("/menu#ns");
            else
                navigate("/customer");
        }
    }

    return <div className="Welcome" style={styles?.startPage.backgroundImage ? { backgroundImage: `url(${getHost()}${styles.startPage.backgroundImage})` } : {}}>
        <div className="welcomeTypes">
            {isRetail()
                ? <>
                    <div className="buttons">
                        <div className="button" onClick={() => setType(OrderType.TAKEAWAY)}>
                            <div className="icon">
                                <IconTakeaway />
                            </div>
                            <div className="text">
                                {t("startOrder")}
                            </div>
                        </div>
                    </div>

                    <div className="instructions">
                        <div>{t("retail.line1")}</div>
                        <div>{t("retail.line2")}</div>
                        <div>{t("retail.line3")}</div>
                    </div>
                </>
                : <>
                    <div>{t("welcome")}</div>
                    <div className="buttons">
                        {getAllowedTypes() === OrderType.TAKEAWAY
                            ? null
                            : <div className="button" onClick={() => setType(OrderType.EAT_IN)}>
                                <div className="icon">
                                    <IconRest />
                                </div>
                                <div className="text">
                                    {t("eatIn")}
                                </div>
                            </div>
                        }

                        {getAllowedTypes() === OrderType.EAT_IN
                            ? null
                            : <div className="button" onClick={() => setType(OrderType.TAKEAWAY)}>
                                <div className="icon">
                                    <IconTakeaway />
                                </div>
                                <div className="text">
                                    {t("takeaway")}
                                </div>
                            </div>
                        }
                    </div>
                </>
            }
        </div>
        <div className="language">
            <div>
                {t("chooseLang")}
            </div>
            <div className="buttons">
                {languages.map(x => <div key={`lang_${x}`} className={`button ${i18n.language.toLowerCase().indexOf(x) !== -1 ? "active" : ""}`} onClick={() => changeLang(x)}>
                    <div className="text">{t(`languages.${x}`)}</div>
                    <div className="check">
                        {i18n.language.toLowerCase().indexOf(x) !== -1
                            ? <IconCheck />
                            : null
                        }
                    </div>
                </div>)}
            </div>
        </div>
    </div>
}

export default Welcome;
